import { render, staticRenderFns } from "./TaskManager.vue?vue&type=template&id=0b552258&scoped=true&"
import script from "./TaskManager.vue?vue&type=script&lang=js&"
export * from "./TaskManager.vue?vue&type=script&lang=js&"
import style0 from "./TaskManager.vue?vue&type=style&index=0&id=0b552258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b552258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b552258')) {
      api.createRecord('0b552258', component.options)
    } else {
      api.reload('0b552258', component.options)
    }
    module.hot.accept("./TaskManager.vue?vue&type=template&id=0b552258&scoped=true&", function () {
      api.rerender('0b552258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/taskmanager/TaskManager.vue"
export default component.exports